<template>
    <div>
        <nsw-menu v-show="showMenu"></nsw-menu>
        <breadcrumb
            :main_cate_title="cateTitle"
            :sub_cate_title="subcateTitle"
            :isShowFilter="isShowFilter"
            :total_resources="storeResource.total_resources"
        >
        </breadcrumb>
        <div
            slot="search-result"
            :total_resources="storeResource.total_resources"
        ></div>
        <div slot="filter-control"></div>
        <div
            class="basic-message-box"
            v-show="storeResource.total_resources === 0"
        >
            <p>
                {{
                    is_demo_user && is_demo_displayable
                        ? lang($t("Customer use only"))
                        : lang($t("Coming soon"))
                }}
            </p>
        </div>

        <template v-if="storeResource.content_type === 'single'">
            <div
                class="content-wrapper resources"
                v-show="storeResource.total_resources > 0"
            >
                <h3 class="title-head">{{ storeResource.table_heading }}</h3>

                <div class="obj-resources-table">
                    <!--thead-->
                    <SubCateListTableHeading
                        v-bind:table_key="-1"
                    ></SubCateListTableHeading>
                    <!--tbody-->
                    <SubCateListItem
                        v-bind:cate_list="storeResource.cate_list"
                    ></SubCateListItem>
                    <!---end tbody-->
                </div>
            </div>
        </template>
        <template v-else>
            <div v-show="storeResource.total_resources > 0">
                <div
                    class="content-wrapper resources"
                    v-for="(resources, table_key) in storeResource.cate_list"
                    v-show="getGroupResourceTotal(resources) > 0"
                >
                    <h3 class="title-head">{{ resources.heading }}</h3>

                    <div class="obj-resources-table">
                        <!--thead-->
                        <SubCateListTableHeading
                            v-bind:table_key="table_key"
                        ></SubCateListTableHeading>
                        <!--tbody-->
                        <SubCateListItem
                            v-bind:cate_list="resources.resource"
                        ></SubCateListItem>
                        <!---end tbody-->
                    </div>
                </div>
            </div>
        </template>

        <subcate-footer
            v-show="showFooter"
            :show_batch_btn_goodnotes="display_goodnotes_batch_button()"
        ></subcate-footer>
    </div>
</template>

<script>
//TODO: user path alias
import Vue from "vue";
import axios from "axios";
import router from "@js/routes";
import { common } from "@mixins/common";
import { storeMapper } from "@mixins/storeMapper";
import api from "@js/api";
import EventBus from "@common/eventBus";
import HkepCheckBox from "@/HkepCheckBox";
import HkepLabel from "@/HkepLabel";
import HkepDisplayFormatSize from "@/HkepDisplayFormatSize";
import SubCateListTableHeading from "@/SubCateListTableHeading";
import SubCateListItem from "@/SubCateListItem";
import XAPIJS from "xapijs";

export default {
    name: "SubCateList",
    mixins: [common, storeMapper],
    components: {
        HkepCheckBox,
        HkepLabel,
        HkepDisplayFormatSize,
        SubCateListTableHeading,
        SubCateListItem
    },
    data: function() {
        return {
            content_type: "single",
            subCateId: null, //the subcate id for getting the resource data
            cateTitle: null, //main cate title
            //cateBgColor:null, //main cate background color; used to display on breadcrumb (on desktop screen)
            subcateTitle: null, //sub cate title
            isShowFilter: false, //whether show the filter button or not)
            showFooter: true,
            showMenu: true,
            is_demo_displayable: is_demo_displayable,
            is_demo_user: is_demo_user,
            fetchRequestSeq: 0
        };
    },
    computed: {
        status() {
            return this.$route.query.status;
        }
    },
    /**
     * 當路由有更新, 例如 [YOUR_IP:PORT]/sub_cate_list?id=XXX 當中的 URL query param XXX 轉變時,beforeRouteUpdate 會 listen;
     * sub cate id 有更新後只要再 fetchData 便可; fetchData 裏會讀取 URL query param
     */
    beforeRouteUpdate(to, from, next) {
        next();
        this.getCateDataFromQuery();
        this.fetchData();
    },
    /**路由相處理
     * 第一次進入本頁面時的動作。
     * @param to
     * @param from
     * @param next
     */
    beforeRouteEnter(to, from, next) {
        //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
        next(vm => {
            EventBus.$emit("showGlobalLoading");
            Promise.all(
                [api.getMainCate(), api.getDownloadData()]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                    .map(p => p.catch(() => undefined))
            ).then(
                axios.spread((responseMainCate, responseDownloadData) => {
                    if (responseMainCate) {
                        vm.setWebSiteAndCate(responseMainCate.data, vm);
                    }

                    if (responseDownloadData) {
                        vm.$store.commit(
                            "my_download_store/updateData",
                            responseDownloadData.data
                        );
                    }

                    vm.getCateDataFromQuery();
                    vm.fetchData();
                })
            );
            /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */
        });
    },
    mounted() {
        EventBus.$on("unselect_all_subcate", this.handleUnselectAllSubcate);
        if (!access_token) {
            this.showFooter = false;
        }
    },
    beforeDestroy() {
        EventBus.$off("unselect_all_subcate", this.handleUnselectAllSubcate);
    },
    methods: {
        fetchData() {
            const requestSeq = ++this.fetchRequestSeq;
            EventBus.$emit("showGlobalLoading");
            api.getSubcateByIdFaster(this.subCateId, this.status)
                .then(resp => {
                    if (requestSeq !== this.fetchRequestSeq) {
                        return;
                    }
                    this.$store.commit("resource_store/setCateData", {
                        cate_title: resp.data.col_title,
                        cate_list: resp.data.resources,
                        table_heading: resp.data.table_heading,
                        total_resources: resp.data.count,
                        content_type: resp.data.content_type,
                        mobile_order: resp.data.mobile_order,
                        filter: resp.data.filter,
                        download_display_type: resp.data.download_display_type
                    });

                    if (this.storeResource.content_type === "group") {
                        for (
                            var key = 0;
                            key < this.storeResource.cate_list.length;
                            key++
                        ) {
                            this.storeResource.check_all_group_resource[
                                key
                            ] = false;
                        }
                    } else {
                        this.storeResource.check_all_resource = false;
                    }

                    if (this.checkIsShowFilter()) {
                        EventBus.$emit("setCriteria", resp.data.filter);
                    }

                    this.updateRelationUrl(this.subCateId);

                    this.$store.commit("resource_store/clear_sub_cate");

                    EventBus.$emit("unselect_all_subcate");

                    this.previewMode();
                })
                .catch(resp => {
                    if (requestSeq !== this.fetchRequestSeq) {
                        return;
                    }
                    EventBus.$emit("hideGlobalLoading");
                    //catch 之後的 then(), 無論 axios 成功或是失敗, 總會執行
                })
                .then(() => {
                    if (requestSeq !== this.fetchRequestSeq) {
                        return;
                    }
                    this.resetMainAppSize();

                    Vue.nextTick(() => {
                        if (window.MathJax) {
                            window.MathJax.Hub.Queue(
                                ["Typeset", window.MathJax.Hub],
                                () => {
                                    EventBus.$emit("closeMobileMenu");
                                    EventBus.$emit("hideGlobalLoading");
                                }
                            );
                        }
                    });
                });

            let xapijs = new XAPIJS(xapi_config, access_token);

            xapijs.attended(
                display_name,
                membercode,
                window.location.href,
                this.subCateId
            );
        },
        handleUnselectAllSubcate() {
            if (this.storeResource.content_type === "single") {
                this.storeResource.cate_list.forEach(function(item, index) {
                    if (
                        item.allow_use === true &&
                        item.allow_download === true
                    ) {
                        Vue.set(item, "check", false);
                    }
                });
            } else {
                if (this.storeResource.cate_list) {
                    this.storeResource.cate_list.forEach(function(
                        item,
                        index
                    ) {
                        if (item.resource && item.resource.length > 0) {
                            item.resource.forEach(function(resource_item) {
                                if (
                                    resource_item.allow_use === true &&
                                    resource_item.allow_download === true
                                ) {
                                    Vue.set(resource_item, "check", false);
                                }
                            });
                        }
                    });
                }
            }
        },
        /**
         * Get the individual group resource total,
         * so that the entire group can be hidden if no result after filtering
         */
        getGroupResourceTotal(resources) {
            if (!resources.resource) {
                return 0;
            }
            let dispalyable = resources.resource.filter(el => {
                return el.is_filtered === null || el.is_filtered === false;
            });

            return dispalyable.length;
        },
        /**
         * Display after getting the main cate and sub cate data
         */
        getCateDataFromQuery() {
            let mainCateItem, subCateItem;

            mainCateItem = this.storeCate.cateItem.find(
                (item, index, array) => {
                    return item.id === this.$route.params.cate_id;
                }
            );

            if (!mainCateItem) {
                router.push({ name: "NotFound" });
            } else {
                subCateItem = mainCateItem.subcate.find(
                    (item, index, array) => {
                        return item.id === this.$route.params.subcate_id;
                    }
                );

                if (!subCateItem) {
                    router.push({ name: "NotFound" });
                } else {
                    this.cateTitle = mainCateItem["title"];
                    //this.cateBgColor = mainCateItem["bgcolor"];
                    this.subCateId = this.$route.params.subcate_id;
                    this.subcateTitle = subCateItem["title"];
                }
            }
        },
        /**
         * Check to see if at least one criteria has options. If not, don't display the filter button
         */
        checkIsShowFilter() {
            this.isShowFilter = false;

            if (!this.storeResource.total_resources) {
                return;
            }

            let classificationCount = 0;
            for (let item of this.storeResource.filter) {
                if (item.classification && item.options) {
                    classificationCount++;
                }
            }

            if (classificationCount > 0) {
                this.isShowFilter = true;
                return true;
            }

            return false;
        },
        previewMode() {
            if (this.status === "Draft") {
                this.showFooter = false;
                // this.showFooter = true;
                this.showMenu = false;

                EventBus.$emit("hideHeader");
            }
        },
        display_goodnotes_batch_button() {
            return is_goodnotes_batch_button_visible;
        }
    }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/SubCateList.vue